"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
// import styles from './styles';
const moment_1 = __importDefault(require("moment"));
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const ModalConfirm_1 = __importDefault(require("../../../components/modal/ModalConfirm"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const RepCommentArticleScreen = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { article, comment = null, type, target_comment_id } = props.route?.params;
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [value, setValue] = (0, react_1.useState)('');
    const [dataComment, setDataComment] = (0, react_1.useState)(null);
    const [dataEdit, setDataEdit] = (0, react_1.useState)(null);
    const [visibleConfirm, setVisibleConfirm] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        if (connected) {
            if (comment) {
                callApiComment();
            }
            else if (type == 'EDIT' && target_comment_id) {
                callApiCommentOld();
            }
            else {
                setIsLoading(false);
            }
        }
    }, [connected]);
    const callApiComment = async () => {
        await Article_1.default.CommentDetail({ comment, page: 1 })
            .then((res) => {
            if (type == 'POST') {
                setDataComment(res?.data);
                setIsLoading(false);
            }
            else if (type == 'EDIT') {
                setDataEdit(res?.data);
                setValue(res?.data?.comment_text);
                setIsLoading(false);
            }
        })
            .catch((err) => {
            console.log('err', err);
        });
    };
    const callApiCommentOld = async () => {
        await Article_1.default.CommentDetail({ comment: target_comment_id, page: 1 })
            .then((res) => {
            setDataComment(res?.data);
        })
            .catch((err) => {
            console.log('err', err);
        });
    };
    const commentArticle = async () => {
        if (comment) {
            let data = {
                target_content_type: 2,
                target_article_id: article,
                target_comment_id: dataComment?.article_comment_id,
                comment_text: value,
            };
            await Article_1.default.RepComment(data)
                .then((_res) => {
                dispatch(slice_1.default.actions.showToast('コメントしました'));
                (0, rootNavigation_1.goBack)();
            })
                .catch((_err) => { });
        }
        else {
            let data = {
                target_content_type: 1,
                target_article_id: article,
                comment_text: value,
            };
            await Article_1.default.RepComment(data)
                .then((_res) => {
                dispatch(slice_1.default.actions.showToast('コメントしました'));
                (0, rootNavigation_1.goBack)();
            })
                .catch((_err) => { });
        }
    };
    const editCommentArticle = async () => {
        let data = { idComment: comment, data: { comment_text: value } };
        await Article_1.default.editCommentArticle(data)
            .then((_res) => {
            dispatch(slice_1.default.actions.showToast('コメントを編集しました'));
            (0, rootNavigation_1.goBack)();
        })
            .catch((_err) => { });
    };
    const navigateToUserProfile = (userHandle) => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: userHandle,
            },
        });
    };
    const nickname = comment && dataComment ? dataComment?.nickname : dataUser?.nickname;
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
        }, pointerEvents: "box-none", onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: '\u30B3\u30E1\u30F3\u30C8\u6295\u7A3F', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(12),
                    lineHeight: (0, scale_1.moderateScale)(18),
                    fontWeight: '300',
                    color: '#007AFF',
                } }, "\u30AD\u30E3\u30F3\u30BB\u30EB"), onLeftPress: () => {
                if (value?.length > 0) {
                    setVisibleConfirm(true);
                }
                else {
                    (0, rootNavigation_1.goBack)();
                }
            }, rightIcon: react_1.default.createElement(CustomText_1.default, { style: {
                    fontSize: (0, scale_1.moderateScale)(12),
                    lineHeight: (0, scale_1.moderateScale)(18),
                    fontWeight: '300',
                    color: '#007AFF',
                } }, "\u6295\u7A3F"), onRightPress: () => {
                if (type == 'POST') {
                    commentArticle();
                }
                else if (type == 'EDIT') {
                    editCommentArticle();
                }
            } }),
        react_1.default.createElement(react_native_1.View, { style: { paddingHorizontal: (0, scale_1.scale)(16), flex: 1 } }, isLoading ? (react_1.default.createElement(react_native_1.View, { style: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: '#F5FCFF88',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement(react_native_1.ActivityIndicator, { size: "large", color: '#286D84' }))) : (react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false },
            comment && dataComment && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        flexDirection: 'row',
                        marginBottom: (0, scale_1.scale)(12),
                        paddingTop: (0, scale_1.scale)(20),
                    }, onPress: () => navigateToUserProfile(dataComment?.user_handle) },
                    react_1.default.createElement(react_native_1.Image, { source: dataComment?.thumbnail_url
                            ? { uri: dataComment?.thumbnail_url }
                            : images_1.images.AvatarDefaul, style: {
                            height: (0, scale_1.scale)(42),
                            width: (0, scale_1.scale)(42),
                            marginRight: (0, scale_1.scale)(12),
                            borderRadius: 99,
                        } }),
                    react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(290), justifyContent: 'center' } },
                        react_1.default.createElement(react_native_1.View, { style: {
                                flexDirection: 'row',
                                alignItems: 'center',
                            } },
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                                    fontSize: (0, scale_1.moderateScale)(14),
                                    lineHeight: (0, scale_1.moderateScale)(21),
                                    color: '#292A33',
                                    maxWidth: (0, scale_1.scale)(190),
                                }, numberOfLines: 1 }, dataComment?.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(10),
                                    lineHeight: (0, scale_1.moderateScale)(17),
                                    fontWeight: '300',
                                    color: '#888888',
                                    marginLeft: (0, scale_1.scale)(12),
                                    width: (0, scale_1.scale)(98),
                                }, numberOfLines: 1 }, (0, moment_1.default)(dataComment?.created_at, 'YYYY-MM-DD HH:mm:ss').format('YYYY/MM/DD H:mm'))),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(10),
                                lineHeight: (0, scale_1.moderateScale)(17),
                                fontWeight: '300',
                                color: '#545454',
                                marginTop: (0, scale_1.scale)(4),
                            } },
                            "@",
                            dataComment?.user_handle))),
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                    react_1.default.createElement(react_native_1.View, { style: {
                            width: (0, scale_1.scale)(40),
                            alignItems: 'center',
                        } },
                        react_1.default.createElement(react_native_1.View, { style: {
                                width: 2,
                                backgroundColor: '#DDDDDD',
                                flex: 1,
                            } })),
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(CustomText_1.default, { style: {
                                color: '#292A33',
                                fontSize: (0, scale_1.moderateScale)(15),
                                fontWeight: '300',
                                lineHeight: (0, scale_1.moderateScale)(23),
                                marginTop: (0, scale_1.scale)(8),
                                width: (0, scale_1.scale)(290),
                                marginBottom: (0, scale_1.scale)(20),
                            } }, dataComment?.comment_text))))),
            react_1.default.createElement(react_native_1.View, { style: {
                    flexDirection: 'row',
                    marginBottom: (0, scale_1.scale)(12),
                    marginTop: (0, scale_1.scale)(12),
                } },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: {
                        alignItems: 'center',
                        ...react_native_1.Platform.select({
                            web: {
                                cursor: 'default',
                            }
                        }),
                    }, onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.MY_PROFILE,
                        });
                    } },
                    react_1.default.createElement(react_native_1.Image, { source: dataUser?.thumbnail_url
                            ? { uri: dataUser?.thumbnail_url }
                            : images_1.images.AvatarDefaul, style: {
                            height: (0, scale_1.scale)(42),
                            width: (0, scale_1.scale)(42),
                            marginRight: (0, scale_1.scale)(12),
                            borderRadius: 99,
                        } })),
                react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(240), justifyContent: 'center' } },
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(12),
                            lineHeight: (0, scale_1.moderateScale)(18),
                            fontWeight: '300',
                            color: '#292A33',
                        } }, `${comment && dataComment ? `コメント先:` : ''}${nickname || constants_1.DEFAULT_NAME}`),
                    react_1.default.createElement(components_1.AutoHeightInput, { style: {
                            marginTop: (0, scale_1.scale)(8),
                            width: '100%',
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(22.5),
                            color: '#292A33',
                        }, placeholder: "\u30B3\u30E1\u30F3\u30C8\u3092\u6295\u7A3F", placeholderTextColor: '#C8C8C8', value: value, onChangeText: (text) => setValue(text), maxLength: 2000 })))))),
        react_1.default.createElement(ModalConfirm_1.default, { visible: visibleConfirm, onClose: () => setVisibleConfirm(false), title: "\u30B3\u30E1\u30F3\u30C8\u5165\u529B\u3092\u4E2D\u6B62\u3057\u307E\u3059\u304B\uFF1F", content: "\u5165\u529B\u3057\u305F\u30B3\u30E1\u30F3\u30C8\u306F\u4FDD\u5B58\u3055\u308C\u307E\u305B\u3093\u3002", onConfirm: rootNavigation_1.goBack, confirmLabel: "\u30B3\u30E1\u30F3\u30C8\u3092\u7834\u68C4", cancelLabel: "\u7D9A\u3051\u308B" })));
};
exports.default = RepCommentArticleScreen;
